import { MutableRefObject, useCallback, useEffect, useRef } from 'react'
import { HiBars3BottomRight, HiOutlineXMark } from 'react-icons/hi2'
import { useDispatch, useSelector } from 'react-redux'
import Logo from 'src/components/atoms/Logo/Logo'
import RoundButton from 'src/components/atoms/RoundButton/RoundButton'
import Portal from 'src/components/helpers/Portal/Portal'
import { getLayerById } from 'src/selectors/layers'
import { toggleLayer } from 'src/state/layers'
import { RootState } from 'src/store'
import * as Styles from './Header.style'
import { selectIsLoading } from 'src/state/layout'
import { AnimatePresence, motion } from 'framer-motion'
import { getSettings } from 'src/selectors/settings'
import { Link } from 'react-router-dom'
import Text from 'src/components/atoms/Text/Text'
import FlexWrapper from 'src/components/_layout/FlexWrapper/FlexWrapper'

const Header: React.FC = (props) => {
    const ref = useRef() as MutableRefObject<HTMLDivElement>
    const isLoading = useSelector(selectIsLoading)
    const dispatch = useDispatch()
    const { languages } = useSelector(getSettings)
    const menuLayer = useSelector((state: RootState) =>
        getLayerById(state, 'mainMenu')
    )
    const toggleMenu = useCallback(() => {
        if (menuLayer) {
            dispatch(
                toggleLayer({
                    layerId: menuLayer.id,
                })
            )
        }
    }, [dispatch, menuLayer])

    useEffect(() => {
        if (ref.current && !isLoading) {
            const appElement =
                document.querySelector<HTMLDivElement>('.scroll-content')
            if (appElement) {
                appElement.style.paddingTop = `${ref.current.offsetHeight}px`
            }
        }
    }, [isLoading])

    return (
        <Portal domQuery="#root">
            <Styles.Wrapper ref={ref}>
                <FlexWrapper align="center" css={{ gap: '$xxs' }}>
                    {Object.keys(languages).map((key, index) => (
                        <>
                            <Text
                                as={Link}
                                key={key}
                                to={`/${languages[key].code}`}
                                textVariant="small2"
                            >
                                {languages[key].code.toUpperCase()}
                            </Text>
                            {index < Object.keys(languages).length - 1 && (
                                <Text textVariant="small2"> | </Text>
                            )}
                        </>
                    ))}
                </FlexWrapper>
                <Styles.LogoWrapper>
                    <Logo />
                </Styles.LogoWrapper>
                <Styles.MenuWrapper>
                    <div>
                        <RoundButton
                            aria-label="Open Menu"
                            onClick={toggleMenu}
                            css={{
                                borderColor: '$background',
                                color: '$background',
                            }}
                        >
                            <AnimatePresence initial={false}>
                                {menuLayer?.isActive ? (
                                    <motion.span
                                        key="close"
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        exit={{ opacity: 0 }}
                                        style={{
                                            width: '40px',
                                            height: '40px',
                                            position: 'absolute',
                                            left: '50%',
                                            top: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            zIndex: -1,
                                        }}
                                    >
                                        <HiOutlineXMark
                                            color="#fff"
                                            fontSize={'2.5rem'}
                                        />
                                    </motion.span>
                                ) : (
                                    <motion.span
                                        key="open"
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        exit={{ opacity: 0 }}
                                        style={{
                                            width: '40px',
                                            height: '40px',
                                            position: 'absolute',
                                            left: '50%',
                                            top: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            zIndex: -1,
                                        }}
                                    >
                                        <HiBars3BottomRight
                                            color="#fff"
                                            fontSize={'2.5rem'}
                                        />
                                    </motion.span>
                                )}
                            </AnimatePresence>
                        </RoundButton>
                    </div>
                </Styles.MenuWrapper>
            </Styles.Wrapper>
        </Portal>
    )
}
export default Header
